import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import {    getProductsByCountryCode} from "@/services/productServices/productActions";
import { getPagesByCurrentSite } from "@/services/pageServices/pageAction";
import { getCurrentSite } from "@/services/siteServices/siteActions";
import { getSiteCategories } from "@/services/categoryServices/categoryAction";
import DashboardView from "./DashboardView";

const DashboardContainer = () => {
  
  const [CatlimitTo, setCatLimit] = useState(3);
  const [ProdlimitTo, setProdLimit] = useState(3);
  const [PagelimitTo, setPageLimit] = useState(3);  
  const pages = useAppSelector((s) => s.pages?.pages || []);
  const productsState = useAppSelector((s) => s.products);
  const products = productsState?.products_country_code || [];
  const categories = useAppSelector((s) => s.categories?.siteCategories || []);
  const dispatch = useAppDispatch();

  useEffect(() => {
   
    const origin = window?.location?.origin || "";
   
    const newcurrent = origin.replace(/^https?:\/\//, "");
    (async () => {
      await dispatch(getCurrentSite(newcurrent));
      await dispatch(getProductsByCountryCode());
      await dispatch(getSiteCategories());
      await dispatch(getPagesByCurrentSite());
     
    })();
  }, [dispatch]);


  const onLoadMoreCat = useCallback(() => setCatLimit((v) => v + 3), []);
  const onLoadMoreProd = useCallback(() => setProdLimit((v) => v + 3), []);
  const onLoadMorePage = useCallback(() => setPageLimit((v) => v + 3), []);

  return (
    <DashboardView
      siteCategories={categories}
      products={products}
      pages={pages}
      CatlimitTo={CatlimitTo}
      ProdlimitTo={ProdlimitTo}
      PagelimitTo={PagelimitTo}
      onLoadMoreCat={onLoadMoreCat}
      onLoadMoreProd={onLoadMoreProd}
      onLoadMorePage={onLoadMorePage}
    />
  );
};

export default DashboardContainer;
